export default __webpack_public_path__ + "static/media/breadcrumb.f7feae26.jpg";